var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 11,
    viewBox: "0 0 25 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Battery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5C0.5 3.79168 0.500389 3.29052 0.5324 2.89872C0.563934 2.51276 0.623645 2.27717 0.717987 2.09202C0.909734 1.71569 1.21569 1.40973 1.59202 1.21799C1.77717 1.12365 2.01276 1.06393 2.39872 1.0324C2.79052 1.00039 3.29168 1 4 1H18C18.7083 1 19.2095 1.00039 19.6013 1.0324C19.9872 1.06393 20.2228 1.12365 20.408 1.21799C20.7843 1.40973 21.0903 1.7157 21.282 2.09202C21.3764 2.27717 21.4361 2.51276 21.4676 2.89872C21.4996 3.29052 21.5 3.79168 21.5 4.5V7C21.5 7.70832 21.4996 8.20948 21.4676 8.60128C21.4361 8.98724 21.3764 9.22283 21.282 9.40798C21.0903 9.7843 20.7843 10.0903 20.408 10.282C20.2228 10.3764 19.9872 10.4361 19.6013 10.4676C19.2095 10.4996 18.7083 10.5 18 10.5H4C3.29168 10.5 2.79052 10.4996 2.39872 10.4676C2.01276 10.4361 1.77717 10.3764 1.59202 10.282C1.2157 10.0903 0.909734 9.7843 0.717987 9.40798C0.623645 9.22283 0.563934 8.98724 0.5324 8.60128C0.500389 8.20948 0.5 7.70832 0.5 7V4.5Z",
    stroke: "#3F4254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5C0.5 3.79168 0.500389 3.29052 0.5324 2.89872C0.563934 2.51276 0.623645 2.27717 0.717987 2.09202C0.909734 1.71569 1.21569 1.40973 1.59202 1.21799C1.77717 1.12365 2.01276 1.06393 2.39872 1.0324C2.79052 1.00039 3.29168 1 4 1H18C18.7083 1 19.2095 1.00039 19.6013 1.0324C19.9872 1.06393 20.2228 1.12365 20.408 1.21799C20.7843 1.40973 21.0903 1.7157 21.282 2.09202C21.3764 2.27717 21.4361 2.51276 21.4676 2.89872C21.4996 3.29052 21.5 3.79168 21.5 4.5V7C21.5 7.70832 21.4996 8.20948 21.4676 8.60128C21.4361 8.98724 21.3764 9.22283 21.282 9.40798C21.0903 9.7843 20.7843 10.0903 20.408 10.282C20.2228 10.3764 19.9872 10.4361 19.6013 10.4676C19.2095 10.4996 18.7083 10.5 18 10.5H4C3.29168 10.5 2.79052 10.4996 2.39872 10.4676C2.01276 10.4361 1.77717 10.3764 1.59202 10.282C1.2157 10.0903 0.909734 9.7843 0.717987 9.40798C0.623645 9.22283 0.563934 8.98724 0.5324 8.60128C0.500389 8.20948 0.5 7.70832 0.5 7V4.5Z",
    stroke: "#181C32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.87398C23.8626 7.65196 24.5 6.86891 24.5 5.93699C24.5 5.00507 23.8626 4.22202 23 4V7.87398Z",
    fill: "#3F4254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.87398C23.8626 7.65196 24.5 6.86891 24.5 5.93699C24.5 5.00507 23.8626 4.22202 23 4V7.87398Z",
    fill: "#181C32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 18,
    height: 6.5,
    rx: 1,
    fill: "#3F4254"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 18,
    height: 6.5,
    rx: 1,
    fill: "#181C32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.33ca29f258910feb91748fa167cc5a6a.svg";
export { ForwardRef as ReactComponent };